import i18n from 'i18n';
import {
  ColDef,
  ITooltipParams,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import GridGroupHeader from 'components/GridGroupHeader';

export enum CollectionFunctionGroupMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
}

/**
 * This value must be set in common-grid columnDefsVersion property. So, updating this value
 * forces common-grid to use the in code columnDefs instead of the saved grid setting.
 */
export const collectionFunctionGroupColumnDefsVersion = '1';

export const collectionFunctionGroupColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('collectionFunctionGroup.grid.name'),
    field: 'name',
    rowGroup: true,
    hide: true,
    lockVisible: true,
  },
  {
    headerName: i18n.t('collectionFunctionGroup.grid.description'),
    field: 'description',
    tooltipField: 'description',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    maxWidth: 340,
    aggFunc: 'first',
    tooltipValueGetter: (params: Partial<ITooltipParams>): string => {
      if (params.node?.group) {
        return params.value;
      }

      return '';
    },
    cellRenderer: (params: Partial<ValueFormatterParams>): string => {
      if (params.node?.group) {
        return params.value;
      }

      return '';
    },
  },
  {
    headerName: i18n.t('collectionFunctionGroup.grid.collectionFunction'),
    field: 'collectionFunction',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'collectionFunction',
    flex: 1,
    maxWidth: 340,
  },
];

export const collectionFunctionGroupAutoGroupColumnDef: ColDef = {
  headerName: i18n.t('collectionFunctionGroup.grid.name'),
  sortable: true,
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  resizable: false,
  flex: 1,
  maxWidth: 340,
  headerComponentFramework: GridGroupHeader,
  filterValueGetter: (params: Partial<ValueGetterParams>): string => {
    return params.data?.name;
  },
  cellRendererParams: {
    suppressCount: true,
  },
};
